<template>
  <Row>
    <Col span="5">
      <div class="cco-wrapper-label">{{item.key}}：</div>
    </Col>
    <Col span="19" class="cco-wrapper-box">
      <Row :gutter="24" style="width: 100%">
        <Col span="8" v-for="(i, idx) in tagArr" :key="'cco-wrapper-box__item-' + idx">
          <div
            class="cco-wrapper-box__item"
            :class="{
                active: i.active,
                type: i.type === 1,
                type2: i.type === 2,
              }"
            :title="i.value"
            @click="setItemActive(i, idx)"
          >
            <p>{{i.value}}</p>
            <i class="icon iconfont icon-closec" @click.stop="delItem(i, idx)" v-if="i.type === 2"></i>
          </div>
        </Col>
        <Col span="8" class="cco-wrapper-subbox">
          <Poptip @on-ok="addItem" v-model="popOpen" @on-popper-hide="popHide">
            <div class="cco-wrapper-box__item2" :class="{active: index === 1, disable: !open }">+ Add</div>
            <div slot="content" class="cco-pop">
              <div class="cco-pop-top">
                <Input
                  search
                  enter-button="Confirm"
                  v-model="inpVlaue"
                  @on-search="addItem($event, index)"
                  width="200px"
                  :maxlength="6"
                />
              </div>
            </div>
          </Poptip>
        </Col>
      </Row>
    </Col>
  </Row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "custom-objective-type",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {
          active: false,
          input: "",
          key: "擅长领域",
          typeId: 5,
          unit: "",
          value: [""]
        };
      }
    },
    Modal: {
      type: Array,
      default: function() {
        return [];
      }
    },
    open: {
      type: Boolean,
      default: false // 返回的数据数组
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      inpVlaue: "",
      popOpen: false,
      tagArr: [
        // {
        //     type: 1: 接口数据/ 2自定义数据 ,
        //     value: '' , 当前标签值
        //     active: bool值 激活状态
        // }
      ], // 标签数组

      // 1:品牌商—授权渠道,
      // 2:品牌商—招募地区,
      // 3:工厂—服务范围,
      // 4:工厂—代工类型,
      // 5:服务商—擅长领域,
      // 6:服务商—服务地区,
      // 7:加盟商—店铺类型,
      // 8:加盟商—招募地区,
      // 9:其他文本
      typeArr: [
        "", // 为了排列从 1 开始
        "授权渠道",
        "招募地区",
        "服务范围",
        "代工类型",
        "擅长领域",
        "服务地区",
        "店铺类型",
        "招募地区"
      ]
    };
  },
  watch: {},
  created() { 
    this.init();
  },
  methods: {
    ...mapActions({
      getActionType: "companyModule/getActionType"
    }),
    init() {
      this.getTypeData();
    },

    async getTypeData() {
      // 获取类型数据 和 自定义添加的数据
      const num = this.item.typeId;
      const type = await this.getActionType(num);
      let copyModal = JSON.parse(JSON.stringify(this.item));
      let copyValue = null;
      const filterType = []; // 接口数据
      const filterTypeValues = []; // 接口数据的value
      const filterType2 = []; // 自定义数据

      if (copyModal && copyModal.value) {
        // 转换自定义的数据
        copyValue = copyModal.value;
        if (copyValue && copyValue.length) {
          // 自定义数据转换成数组
          copyValue.forEach((c, i) => {
            filterType2.push({ type: 2, value: c, active: true });
          });
        }
      }
      if (type && type.length) {
        // 转换接口数据
        type.forEach((c, i) => {
          filterType.push({ type: 1, value: c.valueEn, active: false });
          filterTypeValues.push(c.valueEn);
        });
      }
      // 根据自定义和转换接口来转化数据
      let obj = {};
      filterType.map(c => {
        filterType2.forEach(v => {
          if (c.value === v.value) {
            c.active = true;
          } else {
            if (!obj[v.value] && filterTypeValues.indexOf(v.value) === -1) {
              filterType.push(v);
              obj[v.value] = "1";
            }
          }
        });
      });

      console.log(this.typeArr[this.item.typeId], filterType);
      this.tagArr = filterType;
    },

    setItemActive(item, i) {
      let bool = this.maxLimit();
      if (item.active) {
        bool = true;
      }
      if (!bool) return;
      this.tagArr[i].active = !this.tagArr[i].active;
      this.sendData();
    },
    addItem(val, idx) {
      // const bool = this.maxLimit();
      // if (!bool) {
      //   this.$Message.warning("标签最多添加四个");
      //   return;
      // } 
      this.tagArr.push({ type: 2, value: val, active: false }); 
      this.inpVlaue = "";
      this.popOpen = false;
      this.sendData();
    },
    maxLimit() {
      let num = 0;
      this.tagArr.forEach(c => {
        if (c.active) num += 1;
      });
      if (num >= 4) {
        return false;
      }
      return true;
    },
    delItem(i, idx) {
      this.tagArr[idx].active = !this.tagArr[idx].active;
      if (i.type === 2) {
        this.tagArr.splice(idx, 1);
      }
      this.sendData();
    },
    sendData() {
      const arr = [];
      this.tagArr.forEach(c => {
        if (c.active) {
          arr.push(c.value);
        }
      });
      this.$emit("changeModal", arr);
    },
    popHide() {
      this.inpVlaue = "";
      this.popOpen = false;
    }
  }
};
</script>

<style scoped lang="scss">
.cco {
  width: 100%;
  &-pop {
    padding: 20px;
    width: 250px;
  }
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ccop {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        position: relative;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  &-wrapper {
    padding-top: 20px;
    font-size: 14px;
    color: #333;
    &-box {
      display: flex;

      &__item {
        width: 100%;
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        border: solid 1px #bfbfbf;
        margin-bottom: 20px;
        position: relative;

        color: #333;
        border-color: #bfbfbf;
        background: #fff;

        &.type {
          &:hover {
            .icon-closec {
              display: block;
            }
          }
        }
        &.type2 {
          border-color: #bfbfbf;
          background: #fff;
          &:hover {
            .icon-closec {
              display: block;
            }
          }
        }

        .icon-closec {
          position: absolute;
          color: red;
          top: -16px;
          right: -12px;
          font-size: 20px;
          cursor: pointer;
          display: none;
        }
        &.active {
          color: #fff;
          border-color: #fe781d;
          background: #fe781d;
          &:hover {
            .icon-closec {
              display: block;
            }
          }
        }
        p {
          width: calc(100% - 1px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      &__item2 {
        color: #1890ff;
        width: 92px;
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        border: dashed 1px #1890ff;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        margin-bottom: 20px;
        &.disable {
          background-color: #f3f3f3;
          color: #ccc;
          border-color: #ccc;
        }
      }
    }
    &-label {
      line-height: 31px;
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
<style lang="scss">
.cco-wrapper-subbox {
  .ivu-poptip {
    width: 100%;
  }
}
</style>
